import { render } from "./invoicingH5.vue?vue&type=template&id=bc3de2a4&scoped=true"
import script from "./invoicingH5.vue?vue&type=script&lang=js"
export * from "./invoicingH5.vue?vue&type=script&lang=js"

import "./invoicingH5.vue?vue&type=style&index=0&id=bc3de2a4&scoped=true&lang=css"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc3de2a4"]])

export default __exports__